import { arrayOf, bool, exact, number, string } from "prop-types";
import { baseDatabaseModelType } from "./baseDatabaseModel";
import { userRoleDocumentType } from "./userRoleDocumentType";

const baseUser = {
  givenName: string,
  surname: string,
  jobTitle: string,
  email: string,
  azureAdAccountEnabled: bool,
  azureAdIsDeleted: bool,
};

const relatedUser = exact({
  ...baseUser,
  id: string.isRequired,
  userPrincipalName: string.isRequired,
});

/** @deprecated use TypeScript interface or type instead */
export const userType = exact({
  ...baseUser,
  ...baseDatabaseModelType,
  id: string,
  userId: string,
  fullName: string,
  fullNameReversed: string,
  userPrincipalName: string,
  tenantId: string,
  department: string,
  officeLocation: string,
  roles: arrayOf(userRoleDocumentType),
  groups: arrayOf(userRoleDocumentType),
  manager: relatedUser,
  mobilePhone: string,
  businessPhones: arrayOf(string),
  directReports: arrayOf(relatedUser),
  cosmosUnixTimestamp: number,
  azureAdUserType: string,
  isHidden: bool,
  exclude: bool,
});
